export default "__VITE_ASSET__cgHLHRRM__"